import { useLocation } from 'react-router'


export default function useWheelId(): string {
    const location = useLocation();
    const wheelId = location.pathname.split('/')[1];
    return wheelId || "my";
}
